import { useState } from 'react';

import useScrollEffect from './useScrollEffect';

/**
 * React hook that will return the current scroll position
 */
const useWindowScrollEffect = () => {
  const [scrollY, setScrollY] = useState();
  const [scrollX, setScrollX] = useState();

  useScrollEffect(() => {
    const { body } = document;
    const { x, y } = body.getBoundingClientRect();
    setScrollX(body.clientLeft - x);
    setScrollY(body.clientTop - y);
  });

  return {
    scrollX,
    scrollY,
  };
};

export default useWindowScrollEffect;
